// =============================================
// PÁGINA: EXECUÇÕES DE AUTOMAÇÃO
// =============================================
// Arquivo: AutomationExecutions.tsx
// Descrição: Página para monitorar execuções de automação em tempo real
// =============================================

import React from 'react';
import ExecutionDashboard from '../../components/Automation/ExecutionDashboard';
import './AutomationExecutions.css';

const AutomationExecutions: React.FC = () => {
  return (
    <div className="automation-executions-page">
      <ExecutionDashboard />
    </div>
  );
};

export default AutomationExecutions;
